import { useTranslation } from 'react-i18next';
import { reservedKeys, useLocalStorage } from 'enova-frontend-components';
import i18n from 'i18next';
import { Dropdown, DropdownTrigger } from '@digdir/designsystemet-react';
import { ChevronDownIcon } from '@navikt/aksel-icons';
import { useState } from 'react';

import { Language } from '../../../../i18n';
import { DropDownButton } from '../../../../screens/building/pages/energiplan/styledComponents';

const LanguageMenu = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [, setLng] = useLocalStorage(reservedKeys.lng.app);

  const curLng = i18n.language as Language;
  const languageKey = curLng === Language.NB_NO ? 'malform.bokmal' : 'malform.nynorsk';

  const changeLanguage = (newLng: Language) => {
    i18n.changeLanguage(newLng);
    setLng(newLng);
    setOpen(false);
  };

  return (
    <Dropdown.TriggerContext>
      <DropdownTrigger variant="tertiary">
        {t(languageKey)}
        <ChevronDownIcon aria-hidden />
      </DropdownTrigger>
      <Dropdown open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)}>
        <Dropdown.List>
          <Dropdown.Item>
            <DropDownButton onClick={() => changeLanguage(Language.NB_NO)}>{t('malform.bokmal')}</DropDownButton>
          </Dropdown.Item>
          <Dropdown.Item>
            <DropDownButton onClick={() => changeLanguage(Language.NN_NO)}>{t('malform.nynorsk')}</DropDownButton>
          </Dropdown.Item>
        </Dropdown.List>
      </Dropdown>
    </Dropdown.TriggerContext>
  );
};

export default LanguageMenu;
